import { ComponentType } from 'react';
import { SvgIconProps } from '@mui/material/SvgIcon';
import MiscellaneousServicesIcon from '@mui/icons-material/MiscellaneousServices';
import { serviceIconMap } from '../../../../src/assets/json-administration-profiles/serviceIcons';

export function resolveServiceIcon(serviceIcon: string): ComponentType<SvgIconProps> {
	return serviceIconMap[serviceIcon] ?? MiscellaneousServicesIcon;
}
